import _classCallCheck from "C:\\TaryagAnalytics\\projects-Git\\code\\basehaseferclient\\basehasefer\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\TaryagAnalytics\\projects-Git\\code\\basehaseferclient\\basehasefer\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _regeneratorRuntime from "C:\\TaryagAnalytics\\projects-Git\\code\\basehaseferclient\\basehasefer\\node_modules\\@babel\\runtime/regenerator";

/**
 * All possible states of a Speechly API client. Failed, NoBrowserSupport and NoAudioConsent states are non-recoverable
 * erroneous states, which should be handled by the end user, according to the semantics of an application.
 * Other states can also be utilized for e.g. enabling and disabling recording buttons or showing the status in the app.
 * It is also possible to use arithmetics for state comparison, e.g. `if (state < speechly.ClientState.Disconnected)`,
 * to react to non-recoverable states.
 * @public
 */
var ClientState;

(function (ClientState) {
  ClientState[ClientState["Failed"] = 0] = "Failed";
  ClientState[ClientState["NoBrowserSupport"] = 1] = "NoBrowserSupport";
  ClientState[ClientState["NoAudioConsent"] = 2] = "NoAudioConsent";
  ClientState[ClientState["__UnrecoverableErrors"] = 3] = "__UnrecoverableErrors";
  ClientState[ClientState["Disconnected"] = 4] = "Disconnected";
  ClientState[ClientState["Disconnecting"] = 5] = "Disconnecting";
  ClientState[ClientState["Connecting"] = 6] = "Connecting";
  ClientState[ClientState["Preinitialized"] = 7] = "Preinitialized";
  ClientState[ClientState["Initializing"] = 8] = "Initializing";
  ClientState[ClientState["Connected"] = 9] = "Connected";
  ClientState[ClientState["Stopping"] = 10] = "Stopping";
  ClientState[ClientState["Starting"] = 11] = "Starting";
  ClientState[ClientState["Recording"] = 12] = "Recording";
})(ClientState || (ClientState = {}));
/**
 * Converts client state value to a string, which could be useful for debugging or metrics.
 * @param state - the state of the client
 * @public
 */


function stateToString(state) {
  var _a;

  return (_a = states.get(state)) !== null && _a !== void 0 ? _a : unknown;
} // TODO: generate this from the enum.


var unknown = 'Unknown';
var states = new Map([[ClientState.Failed, 'Failed'], [ClientState.NoBrowserSupport, 'NoBrowserSupport'], [ClientState.NoAudioConsent, 'NoAudioConsent'], [ClientState.Disconnecting, 'Disconnecting'], [ClientState.Disconnected, 'Disconnected'], [ClientState.Connecting, 'Connecting'], [ClientState.Preinitialized, 'Preinitialized'], [ClientState.Initializing, 'Initializing'], [ClientState.Connected, 'Connected'], [ClientState.Stopping, 'Stopping'], [ClientState.Starting, 'Starting'], [ClientState.Recording, 'Recording']]);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
} // Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).


var getRandomValues;
var rnds8 = new Uint8Array(16);

function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

var REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

function validate(uuid) {
  return typeof uuid === 'string' && REGEX.test(uuid);
}
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */


var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0; // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434

  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return stringify(rnds);
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var base64 = {
  exports: {}
};
/*! http://mths.be/base64 v0.1.0 by @mathias | MIT license */

(function (module, exports) {
  (function (root) {
    // Detect free variables `exports`.
    var freeExports = exports; // Detect free variable `module`.

    var freeModule = module && module.exports == freeExports && module; // Detect free variable `global`, from Node.js or Browserified code, and use
    // it as `root`.

    var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal;

    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
      root = freeGlobal;
    }
    /*--------------------------------------------------------------------------*/


    var InvalidCharacterError = function InvalidCharacterError(message) {
      this.message = message;
    };

    InvalidCharacterError.prototype = new Error();
    InvalidCharacterError.prototype.name = 'InvalidCharacterError';

    var error = function error(message) {
      // Note: the error messages used throughout this file match those used by
      // the native `atob`/`btoa` implementation in Chromium.
      throw new InvalidCharacterError(message);
    };

    var TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'; // http://whatwg.org/html/common-microsyntaxes.html#space-character

    var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g; // `decode` is designed to be fully compatible with `atob` as described in the
    // HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
    // The optimized base64-decoding algorithm used is based on @atk’s excellent
    // implementation. https://gist.github.com/atk/1020396

    var decode = function decode(input) {
      input = String(input).replace(REGEX_SPACE_CHARACTERS, '');
      var length = input.length;

      if (length % 4 == 0) {
        input = input.replace(/==?$/, '');
        length = input.length;
      }

      if (length % 4 == 1 || // http://whatwg.org/C#alphanumeric-ascii-characters
      /[^+a-zA-Z0-9/]/.test(input)) {
        error('Invalid character: the string to be decoded is not correctly encoded.');
      }

      var bitCounter = 0;
      var bitStorage;
      var buffer;
      var output = '';
      var position = -1;

      while (++position < length) {
        buffer = TABLE.indexOf(input.charAt(position));
        bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer; // Unless this is the first of a group of 4 characters…

        if (bitCounter++ % 4) {
          // …convert the first 8 bits to a single ASCII character.
          output += String.fromCharCode(0xFF & bitStorage >> (-2 * bitCounter & 6));
        }
      }

      return output;
    }; // `encode` is designed to be fully compatible with `btoa` as described in the
    // HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa


    var encode = function encode(input) {
      input = String(input);

      if (/[^\0-\xFF]/.test(input)) {
        // Note: no need to special-case astral symbols here, as surrogates are
        // matched, and the input is supposed to only contain ASCII anyway.
        error('The string to be encoded contains characters outside of the ' + 'Latin1 range.');
      }

      var padding = input.length % 3;
      var output = '';
      var position = -1;
      var a;
      var b;
      var c;
      var buffer; // Make sure any padding is handled outside of the loop.

      var length = input.length - padding;

      while (++position < length) {
        // Read three bytes, i.e. 24 bits.
        a = input.charCodeAt(position) << 16;
        b = input.charCodeAt(++position) << 8;
        c = input.charCodeAt(++position);
        buffer = a + b + c; // Turn the 24 bits into four chunks of 6 bits each, and append the
        // matching character for each of them to the output.

        output += TABLE.charAt(buffer >> 18 & 0x3F) + TABLE.charAt(buffer >> 12 & 0x3F) + TABLE.charAt(buffer >> 6 & 0x3F) + TABLE.charAt(buffer & 0x3F);
      }

      if (padding == 2) {
        a = input.charCodeAt(position) << 8;
        b = input.charCodeAt(++position);
        buffer = a + b;
        output += TABLE.charAt(buffer >> 10) + TABLE.charAt(buffer >> 4 & 0x3F) + TABLE.charAt(buffer << 2 & 0x3F) + '=';
      } else if (padding == 1) {
        buffer = input.charCodeAt(position);
        output += TABLE.charAt(buffer >> 2) + TABLE.charAt(buffer << 4 & 0x3F) + '==';
      }

      return output;
    };

    var base64 = {
      'encode': encode,
      'decode': decode,
      'version': '0.1.0'
    }; // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:

    if (freeExports && !freeExports.nodeType) {
      if (freeModule) {
        // in Node.js or RingoJS v0.8.0+
        freeModule.exports = base64;
      } else {
        // in Narwhal or RingoJS v0.7.0-
        for (var key in base64) {
          base64.hasOwnProperty(key) && (freeExports[key] = base64[key]);
        }
      }
    } else {
      // in Rhino or a web browser
      root.base64 = base64;
    }
  })(commonjsGlobal);
})(base64, base64.exports);

var minTokenValidTime = 60 * 60 * 1000; // 1 hour

function fetchToken(baseUrl, projectId, appId, deviceId) {
  var fetcher = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : fetch;
  var nowFn = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : Date.now;

  var _a;

  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var body, response, json;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (projectId !== undefined) {
              body = {
                projectId: projectId,
                deviceId: deviceId
              };
            } else {
              body = {
                appId: appId,
                deviceId: deviceId
              };
            }

            _context.next = 3;
            return fetcher(baseUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(body)
            });

          case 3:
            response = _context.sent;
            _context.next = 6;
            return response.json();

          case 6:
            json = _context.sent;

            if (!(response.status !== 200)) {
              _context.next = 9;
              break;
            }

            throw Error((_a = json.error) !== null && _a !== void 0 ? _a : "Speechly API login request failed with ".concat(response.status));

          case 9:
            if (!(json.access_token === undefined)) {
              _context.next = 11;
              break;
            }

            throw Error('Invalid login response from Speechly API');

          case 11:
            if (validateToken(json.access_token, projectId, appId, deviceId, nowFn)) {
              _context.next = 13;
              break;
            }

            throw Error('Invalid token received from Speechly API');

          case 13:
            return _context.abrupt("return", json.access_token);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
}

function validateToken(token, projectId, appId, deviceId) {
  var now = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : Date.now;
  var decoded = decodeToken(token);

  if (decoded.expiresAtMs - now() < minTokenValidTime) {
    return false;
  }

  if (decoded.appId !== appId || decoded.projectId !== projectId) {
    return false;
  }

  if (decoded.deviceId !== deviceId) {
    return false;
  }

  return true;
}

function decodeToken(token) {
  var b = token.split('.')[1];
  var body;

  try {
    body = JSON.parse(base64.exports.decode(b));
  } catch (e) {
    throw new Error('Error decoding Speechly token!');
  }

  return {
    appId: body.appId,
    projectId: body.projectId,
    deviceId: body.deviceId,
    configId: body.configId,
    scopes: body.scope.split(' '),
    issuer: body.iss,
    audience: body.aud,
    expiresAtMs: body.exp * 1000 // JWT exp is in seconds, convert to ms, since that's what JS works with.

  };
}
/**
 * Default sample rate for microphone streams.
 * @public
 */


var DefaultSampleRate = 16000;
/**
 * Error to be thrown when the microphone was accessed before it was initialized.
 * @public
 */

var ErrNotInitialized = new Error('Microphone is not initialized');
/**
 * Error to be thrown when the initialize method of a Microphone instance is called more than once.
 * @public
 */

var ErrAlreadyInitialized = new Error('Microphone is already initialized');
/**
 * Error to be thrown when the device does not support the Microphone instance's target audio APIs.
 * @public
 */

var ErrDeviceNotSupported = new Error('Current device does not support microphone API');
/**
 * Error to be thrown when user did not give consent to the application to record audio.
 * @public
 */

var ErrNoAudioConsent = new Error('Microphone consent is no given');
/**
 * Error to be thrown when user tries to change appId without project login.
 * @public
 */

var ErrAppIdChangeWithoutProjectLogin = new Error('AppId changed without project login');
var audioworklet = "\n// Indices for the Control SAB.\nconst CONTROL = {\n  'WRITE_INDEX': 0,\n  'FRAMES_AVAILABLE': 1,\n  'LOCK': 2,\n};\n\nclass SpeechlyProcessor extends AudioWorkletProcessor {\n  constructor() {\n    super();\n\n    this._initialized = false;\n    this.debug = false;\n    this.port.onmessage = this._initialize.bind(this);\n  }\n\n  _initialize(event) {\n    this.controlSAB = new Int32Array(event.data.controlSAB);\n    this.dataSAB = new Float32Array(event.data.dataSAB);\n    this.debug = event.data.debug;\n    this.sharedBufferSize = this.dataSAB.length;\n    this.buffer = new Float32Array(0);\n    this._initialized = true;\n  }\n\n  _transferDataToSharedBuffer(data) {\n    this.controlSAB[CONTROL.LOCK] = 1\n    let inputWriteIndex = this.controlSAB[CONTROL.WRITE_INDEX]\n    if (this.controlSAB[CONTROL.FRAMES_AVAILABLE] > 0) {\n      if (inputWriteIndex + data.length > this.sharedBufferSize) {\n        // console.log('buffer overflow')\n        inputWriteIndex = 0\n      }\n    }\n    this.dataSAB.set(data, inputWriteIndex)\n    this.controlSAB[CONTROL.WRITE_INDEX] = inputWriteIndex + data.length\n    this.controlSAB[CONTROL.FRAMES_AVAILABLE] = inputWriteIndex + data.length\n    this.controlSAB[CONTROL.LOCK] = 0\n  }\n\n  _pushData(data) {\n    if (this.debug) {\n      const signalEnergy = getStandardDeviation(data)\n      this.port.postMessage({\n        type: 'STATS',\n        signalEnergy: signalEnergy\n      });\n    }\n\n    if (this.buffer.length > this.sharedBufferSize) {\n      const dataToTransfer = this.buffer.subarray(0, this.sharedBufferSize)\n      this._transferDataToSharedBuffer(dataToTransfer)\n      this.buffer = this.buffer.subarray(this.sharedBufferSize)\n    }\n    let concat = new Float32Array(this.buffer.length + data.length)\n    concat.set(this.buffer)\n    concat.set(data, this.buffer.length)\n    this.buffer = concat\n  }\n\n  process(inputs, outputs, parameters) {\n    const inputChannelData = inputs[0][0];\n      if (inputChannelData !== undefined) {\n        if (this.controlSAB && this.dataSAB) {\n          this._pushData(inputChannelData);\n        } else {\n          this.port.postMessage({\n            type: 'DATA',\n            frames: inputChannelData\n          });\n        }\n      }\n      \n      return true;\n  }\n}\n\nfunction getStandardDeviation(array) {\n  const n = array.length\n  const mean = array.reduce((a, b) => a + b) / n\n  return Math.sqrt(array.map(x => Math.pow(x - mean, 2)).reduce((a, b) => a + b) / n)\n}\n\nregisterProcessor('speechly-worklet', SpeechlyProcessor);\n";
var audioProcessEvent = 'audioprocess';
var baseBufferSize = 4096;

var BrowserMicrophone =
/*#__PURE__*/
function () {
  function BrowserMicrophone(isWebkit, sampleRate, apiClient) {
    var _this = this;

    var debug = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    _classCallCheck(this, BrowserMicrophone);

    this.initialized = false;
    this.muted = false;
    this.stats = {
      maxSignalEnergy: 0.0
    };

    this.handleAudio = function (array) {
      if (_this.muted) {
        return;
      }

      if (array.length > 0) {
        _this.apiClient.sendAudio(array);
      }
    };

    this.isWebkit = isWebkit;
    this.apiClient = apiClient;
    this.sampleRate = sampleRate;
    this.debug = debug;
  }

  _createClass(BrowserMicrophone, [{
    key: "initialize",
    value: function initialize(audioContext, mediaStreamConstraints) {
      var _a;

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var blob, blobURL, speechlyNode, controlSAB, dataSAB, bufSize;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.mediaDevices) === undefined)) {
                  _context2.next = 2;
                  break;
                }

                throw ErrDeviceNotSupported;

              case 2:
                this.audioContext = audioContext;
                this.resampleRatio = this.audioContext.sampleRate / this.sampleRate;
                _context2.prev = 4;
                _context2.next = 7;
                return window.navigator.mediaDevices.getUserMedia(mediaStreamConstraints);

              case 7:
                this.mediaStream = _context2.sent;
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](4);
                throw ErrNoAudioConsent;

              case 13:
                this.audioTrack = this.mediaStream.getAudioTracks()[0]; // Start audio context if we are dealing with a non-WebKit browser.
                //
                // Non-webkit browsers (currently only Chrome on Android)
                // require that user media is obtained before resuming the audio context.
                //
                // If audio context is attempted to be resumed before `mediaDevices.getUserMedia`,
                // `audioContext.resume()` will hang indefinitely, without being resolved or rejected.

                if (this.isWebkit) {
                  _context2.next = 17;
                  break;
                }

                _context2.next = 17;
                return this.audioContext.resume();

              case 17:
                if (!(window.AudioWorkletNode !== undefined)) {
                  _context2.next = 29;
                  break;
                }

                blob = new Blob([audioworklet], {
                  type: 'text/javascript'
                });
                blobURL = window.URL.createObjectURL(blob);
                _context2.next = 22;
                return this.audioContext.audioWorklet.addModule(blobURL);

              case 22:
                speechlyNode = new AudioWorkletNode(this.audioContext, 'speechly-worklet');
                this.audioContext.createMediaStreamSource(this.mediaStream).connect(speechlyNode);
                speechlyNode.connect(this.audioContext.destination); // @ts-ignore

                if (window.SharedArrayBuffer !== undefined) {
                  // Chrome, Edge, Firefox, Firefox Android
                  // @ts-ignore
                  controlSAB = new window.SharedArrayBuffer(4 * Int32Array.BYTES_PER_ELEMENT); // @ts-ignore

                  dataSAB = new window.SharedArrayBuffer(1024 * Float32Array.BYTES_PER_ELEMENT);
                  this.apiClient.postMessage({
                    type: 'SET_SHARED_ARRAY_BUFFERS',
                    controlSAB: controlSAB,
                    dataSAB: dataSAB
                  });
                  speechlyNode.port.postMessage({
                    type: 'SET_SHARED_ARRAY_BUFFERS',
                    controlSAB: controlSAB,
                    dataSAB: dataSAB,
                    debug: this.debug
                  });
                } else {
                  // Opera, Chrome Android, Webview Anroid
                  if (this.debug) {
                    console.log('[SpeechlyClient]', 'can not use SharedArrayBuffer');
                  }
                }

                speechlyNode.port.onmessage = function (event) {
                  switch (event.data.type) {
                    case 'STATS':
                      if (event.data.signalEnergy > _this2.stats.maxSignalEnergy) {
                        _this2.stats.maxSignalEnergy = event.data.signalEnergy;
                      }

                      break;

                    case 'DATA':
                      _this2.handleAudio(event.data.frames);

                      break;
                  }
                };

                _context2.next = 34;
                break;

              case 29:
                if (this.debug) {
                  console.log('[SpeechlyClient]', 'can not use AudioWorkletNode');
                } // Safari, iOS Safari and Internet Explorer


                if (this.isWebkit) {
                  // Multiply base buffer size of 4 kB by the resample ratio rounded up to the next power of 2.
                  // i.e. for 48 kHz to 16 kHz downsampling, this will be 4096 (base) * 4 = 16384.
                  bufSize = baseBufferSize * Math.pow(2, Math.ceil(Math.log(this.resampleRatio) / Math.log(2)));
                  this.audioProcessor = this.audioContext.createScriptProcessor(bufSize, 1, 1);
                } else {
                  this.audioProcessor = this.audioContext.createScriptProcessor(undefined, 1, 1);
                }

                this.audioContext.createMediaStreamSource(this.mediaStream).connect(this.audioProcessor);
                this.audioProcessor.connect(this.audioContext.destination);
                this.audioProcessor.addEventListener(audioProcessEvent, function (event) {
                  _this2.handleAudio(event.inputBuffer.getChannelData(0));
                });

              case 34:
                this.initialized = true;
                this.mute();

              case 36:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 10]]);
      }));
    }
  }, {
    key: "close",
    value: function close() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var t, stream, proc;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.mute();

                if (this.initialized) {
                  _context3.next = 3;
                  break;
                }

                throw ErrNotInitialized;

              case 3:
                t = this.audioTrack;
                t.enabled = false; // Stop all media tracks

                stream = this.mediaStream;
                stream.getTracks().forEach(function (t) {
                  return t.stop();
                }); // Disconnect and stop ScriptProcessorNode

                if (this.audioProcessor != null) {
                  proc = this.audioProcessor;
                  proc.disconnect();
                } // Unset all audio infrastructure


                this.mediaStream = undefined;
                this.audioTrack = undefined;
                this.audioProcessor = undefined;
                this.initialized = false;

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "mute",
    value: function mute() {
      this.muted = true;
    }
  }, {
    key: "unmute",
    value: function unmute() {
      this.muted = false;
    }
    /**
     * print statistics to console
     */

  }, {
    key: "printStats",
    value: function printStats() {
      if (this.audioTrack != null) {
        var settings = this.audioTrack.getSettings();
        console.log(this.audioTrack.label, this.audioTrack.readyState); // @ts-ignore

        console.log('channelCount', settings.channelCount); // @ts-ignore

        console.log('latency', settings.latency); // @ts-ignore

        console.log('autoGainControl', settings.autoGainControl);
      }

      console.log('maxSignalEnergy', this.stats.maxSignalEnergy);
    }
  }]);

  return BrowserMicrophone;
}();
/**
 * Known WebSocket response types.
 * @public
 */


var WebsocketResponseType;

(function (WebsocketResponseType) {
  WebsocketResponseType["Opened"] = "WEBSOCKET_OPEN";
  WebsocketResponseType["Closed"] = "WEBSOCKET_CLOSED";
  WebsocketResponseType["SourceSampleRateSetSuccess"] = "SOURSE_SAMPLE_RATE_SET_SUCCESS";
  WebsocketResponseType["Started"] = "started";
  WebsocketResponseType["Stopped"] = "stopped";
  WebsocketResponseType["SegmentEnd"] = "segment_end";
  WebsocketResponseType["Transcript"] = "transcript";
  WebsocketResponseType["Entity"] = "entity";
  WebsocketResponseType["Intent"] = "intent";
  WebsocketResponseType["TentativeTranscript"] = "tentative_transcript";
  WebsocketResponseType["TentativeEntities"] = "tentative_entities";
  WebsocketResponseType["TentativeIntent"] = "tentative_intent";
})(WebsocketResponseType || (WebsocketResponseType = {}));

var worker = "/**\n * Known WebSocket response types.\n * @public\n */\nvar WebsocketResponseType;\n(function (WebsocketResponseType) {\n    WebsocketResponseType[\"Opened\"] = \"WEBSOCKET_OPEN\";\n    WebsocketResponseType[\"SourceSampleRateSetSuccess\"] = \"SOURSE_SAMPLE_RATE_SET_SUCCESS\";\n    WebsocketResponseType[\"Started\"] = \"started\";\n    WebsocketResponseType[\"Stopped\"] = \"stopped\";\n})(WebsocketResponseType || (WebsocketResponseType = {}));\nvar CONTROL = {\n    WRITE_INDEX: 0,\n    FRAMES_AVAILABLE: 1,\n    LOCK: 2\n};\nvar WebsocketClient = /** @class */ (function () {\n    function WebsocketClient(ctx) {\n        var _this = this;\n        this.isContextStarted = false;\n        this.isStartContextConfirmed = false;\n        this.shouldResendLastFramesSent = false;\n        this.buffer = new Float32Array(0);\n        this.lastFramesSent = new Int16Array(0); // to re-send after switch context\n        this.debug = false;\n        this.initialized = false;\n        // WebSocket's close handler, called e.g. when\n        // - normal close (code 1000)\n        // - network unreachable or unable to (re)connect (code 1006)\n        // List of CloseEvent.code values: https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent/code\n        this.onWebsocketClose = function (event) {\n            if (_this.debug) {\n                console.log('[SpeechlyClient]', 'onWebsocketClose');\n            }\n            _this.websocket.removeEventListener('open', _this.onWebsocketOpen);\n            _this.websocket.removeEventListener('message', _this.onWebsocketMessage);\n            _this.websocket.removeEventListener('error', _this.onWebsocketError);\n            _this.websocket.removeEventListener('close', _this.onWebsocketClose);\n            _this.websocket = undefined;\n            _this.workerCtx.postMessage({ type: 'WEBSOCKET_CLOSED', code: event.code, reason: event.reason, wasClean: event.wasClean });\n        };\n        this.onWebsocketOpen = function (_event) {\n            if (_this.debug) {\n                console.log('[SpeechlyClient]', 'websocket opened');\n            }\n            if (_this.isContextStarted && !_this.isStartContextConfirmed) {\n                _this.send(_this.outbox);\n            }\n            _this.workerCtx.postMessage({ type: 'WEBSOCKET_OPEN' });\n        };\n        this.onWebsocketError = function (_event) {\n            if (_this.debug) {\n                console.log('[SpeechlyClient]', 'websocket error');\n            }\n        };\n        this.onWebsocketMessage = function (event) {\n            var response;\n            try {\n                response = JSON.parse(event.data);\n            }\n            catch (e) {\n                console.error('[SpeechlyClient] Error parsing response from the server:', e);\n                return;\n            }\n            if (response.type === WebsocketResponseType.Started) {\n                _this.isStartContextConfirmed = true;\n                if (_this.shouldResendLastFramesSent) {\n                    _this.resendLastFrames();\n                    _this.shouldResendLastFramesSent = false;\n                }\n            }\n            _this.workerCtx.postMessage(response);\n        };\n        this.workerCtx = ctx;\n    }\n    WebsocketClient.prototype.init = function (apiUrl, authToken, targetSampleRate, debug) {\n        this.debug = debug;\n        if (this.debug) {\n            console.log('[SpeechlyClient]', 'initialize worker');\n        }\n        this.apiUrl = apiUrl;\n        this.authToken = authToken;\n        this.targetSampleRate = targetSampleRate;\n        this.initialized = true;\n        this.isContextStarted = false;\n        this.connect(0);\n    };\n    WebsocketClient.prototype.setSourceSampleRate = function (sourceSampleRate) {\n        this.sourceSampleRate = sourceSampleRate;\n        this.resampleRatio = this.sourceSampleRate / this.targetSampleRate;\n        if (this.debug) {\n            console.log('[SpeechlyClient]', 'resampleRatio', this.resampleRatio);\n        }\n        if (this.resampleRatio > 1) {\n            this.filter = generateFilter(this.sourceSampleRate, this.targetSampleRate, 127);\n        }\n        this.workerCtx.postMessage({ type: 'SOURSE_SAMPLE_RATE_SET_SUCCESS' });\n        if (isNaN(this.resampleRatio)) {\n            throw Error(\"resampleRatio is NaN source rate is \".concat(this.sourceSampleRate, \" and target rate is \").concat(this.targetSampleRate));\n        }\n    };\n    WebsocketClient.prototype.setSharedArrayBuffers = function (controlSAB, dataSAB) {\n        this.controlSAB = new Int32Array(controlSAB);\n        this.dataSAB = new Float32Array(dataSAB);\n        var audioHandleInterval = this.dataSAB.length / 32; // ms\n        if (this.debug) {\n            console.log('[SpeechlyClient]', 'Audio handle interval', audioHandleInterval, 'ms');\n        }\n        setInterval(this.sendAudioFromSAB.bind(this), audioHandleInterval);\n    };\n    WebsocketClient.prototype.connect = function (timeout) {\n        if (timeout === void 0) { timeout = 1000; }\n        if (this.debug) {\n            console.log('[SpeechlyClient]', 'connect in ', timeout / 1000, 'sec');\n        }\n        setTimeout(this.initializeWebsocket.bind(this), timeout);\n    };\n    WebsocketClient.prototype.initializeWebsocket = function () {\n        if (this.debug) {\n            console.log('[SpeechlyClient]', 'connecting to ', this.apiUrl);\n        }\n        this.websocket = new WebSocket(this.apiUrl, this.authToken);\n        this.websocket.addEventListener('open', this.onWebsocketOpen);\n        this.websocket.addEventListener('message', this.onWebsocketMessage);\n        this.websocket.addEventListener('error', this.onWebsocketError);\n        this.websocket.addEventListener('close', this.onWebsocketClose);\n    };\n    WebsocketClient.prototype.isOpen = function () {\n        return this.websocket !== undefined && this.websocket.readyState === this.websocket.OPEN;\n    };\n    WebsocketClient.prototype.resendLastFrames = function () {\n        if (this.lastFramesSent.length > 0) {\n            this.send(this.lastFramesSent);\n            this.lastFramesSent = new Int16Array(0);\n        }\n    };\n    WebsocketClient.prototype.sendAudio = function (audioChunk) {\n        if (!this.isContextStarted) {\n            return;\n        }\n        if (audioChunk.length > 0) {\n            if (this.resampleRatio > 1) {\n                // Downsampling\n                this.send(this.downsample(audioChunk));\n            }\n            else {\n                this.send(float32ToInt16(audioChunk));\n            }\n        }\n    };\n    WebsocketClient.prototype.sendAudioFromSAB = function () {\n        if (!this.isContextStarted) {\n            this.controlSAB[CONTROL.FRAMES_AVAILABLE] = 0;\n            this.controlSAB[CONTROL.WRITE_INDEX] = 0;\n            return;\n        }\n        if (this.controlSAB == undefined) {\n            return;\n        }\n        var framesAvailable = this.controlSAB[CONTROL.FRAMES_AVAILABLE];\n        var lock = this.controlSAB[CONTROL.LOCK];\n        if (lock == 0 && framesAvailable > 0) {\n            var data = this.dataSAB.subarray(0, framesAvailable);\n            this.controlSAB[CONTROL.FRAMES_AVAILABLE] = 0;\n            this.controlSAB[CONTROL.WRITE_INDEX] = 0;\n            if (data.length > 0) {\n                var frames_1;\n                if (this.resampleRatio > 1) {\n                    frames_1 = this.downsample(data);\n                }\n                else {\n                    frames_1 = float32ToInt16(data);\n                }\n                this.send(frames_1);\n                // 16000 per second, 1000 in 100 ms\n                // save last 250 ms\n                if (this.lastFramesSent.length > 1024 * 4) {\n                    this.lastFramesSent = frames_1;\n                }\n                else {\n                    var concat = new Int16Array(this.lastFramesSent.length + frames_1.length);\n                    concat.set(this.lastFramesSent);\n                    concat.set(frames_1, this.lastFramesSent.length);\n                    this.lastFramesSent = concat;\n                }\n            }\n        }\n    };\n    WebsocketClient.prototype.startContext = function (appId) {\n        if (this.isContextStarted) {\n            console.log('Cant start context: it has been already started');\n            return;\n        }\n        this.isContextStarted = true;\n        this.isStartContextConfirmed = false;\n        if (appId !== undefined) {\n            this.outbox = JSON.stringify({ event: 'start', appId: appId });\n        }\n        else {\n            this.outbox = JSON.stringify({ event: 'start' });\n        }\n        this.send(this.outbox);\n    };\n    WebsocketClient.prototype.stopContext = function () {\n        if (!this.websocket) {\n            throw Error('Cant start context: websocket is undefined');\n        }\n        if (!this.isContextStarted) {\n            console.log('Cant stop context: it is not started');\n            return;\n        }\n        this.isContextStarted = false;\n        this.isStartContextConfirmed = false;\n        var StopEventJSON = JSON.stringify({ event: 'stop' });\n        this.send(StopEventJSON);\n    };\n    WebsocketClient.prototype.switchContext = function (newAppId) {\n        if (!this.websocket) {\n            throw Error('Cant switch context: websocket is undefined');\n        }\n        if (!this.isContextStarted) {\n            console.log('Cant switch context: it is not started');\n            return;\n        }\n        if (newAppId == undefined) {\n            console.log('Cant switch context: new app id is undefined');\n            return;\n        }\n        this.isStartContextConfirmed = false;\n        var StopEventJSON = JSON.stringify({ event: 'stop' });\n        this.send(StopEventJSON);\n        this.shouldResendLastFramesSent = true;\n        this.send(JSON.stringify({ event: 'start', appId: newAppId }));\n    };\n    WebsocketClient.prototype.closeWebsocket = function (websocketCode, reason) {\n        if (websocketCode === void 0) { websocketCode = 1005; }\n        if (reason === void 0) { reason = \"No Status Received\"; }\n        if (this.debug) {\n            console.log('[SpeechlyClient]', 'Websocket closing');\n        }\n        if (!this.websocket) {\n            throw Error('Websocket is not open');\n        }\n        this.websocket.close(websocketCode, reason);\n    };\n    WebsocketClient.prototype.downsample = function (input) {\n        var inputBuffer = new Float32Array(this.buffer.length + input.length);\n        inputBuffer.set(this.buffer, 0);\n        inputBuffer.set(input, this.buffer.length);\n        var outputLength = Math.ceil((inputBuffer.length - this.filter.length) / this.resampleRatio);\n        var outputBuffer = new Int16Array(outputLength);\n        for (var i = 0; i < outputLength; i++) {\n            var offset = Math.round(this.resampleRatio * i);\n            var val = 0.0;\n            for (var j = 0; j < this.filter.length; j++) {\n                val += inputBuffer[offset + j] * this.filter[j];\n            }\n            outputBuffer[i] = val * (val < 0 ? 0x8000 : 0x7fff);\n        }\n        var remainingOffset = Math.round(this.resampleRatio * outputLength);\n        if (remainingOffset < inputBuffer.length) {\n            this.buffer = inputBuffer.subarray(remainingOffset);\n        }\n        else {\n            this.buffer = new Float32Array(0);\n        }\n        return outputBuffer;\n    };\n    WebsocketClient.prototype.send = function (data) {\n        if (this.isOpen()) {\n            try {\n                this.websocket.send(data);\n            }\n            catch (error) {\n                console.log('[SpeechlyClient]', 'Server connection error', error);\n            }\n        }\n    };\n    return WebsocketClient;\n}());\nvar ctx = self;\nvar websocketClient = new WebsocketClient(ctx);\nctx.onmessage = function (e) {\n    switch (e.data.type) {\n        case 'INIT':\n            websocketClient.init(e.data.apiUrl, e.data.authToken, e.data.targetSampleRate, e.data.debug);\n            break;\n        case 'SET_SOURSE_SAMPLE_RATE':\n            websocketClient.setSourceSampleRate(e.data.sourceSampleRate);\n            break;\n        case 'SET_SHARED_ARRAY_BUFFERS':\n            websocketClient.setSharedArrayBuffers(e.data.controlSAB, e.data.dataSAB);\n            break;\n        case 'CLOSE':\n            websocketClient.closeWebsocket(1000, \"Close requested by client\");\n            break;\n        case 'START_CONTEXT':\n            websocketClient.startContext(e.data.appId);\n            break;\n        case 'SWITCH_CONTEXT':\n            websocketClient.switchContext(e.data.appId);\n            break;\n        case 'STOP_CONTEXT':\n            websocketClient.stopContext();\n            break;\n        case 'AUDIO':\n            websocketClient.sendAudio(e.data.payload);\n            break;\n        default:\n            console.log('WORKER', e);\n    }\n};\nfunction float32ToInt16(buffer) {\n    var buf = new Int16Array(buffer.length);\n    for (var l = 0; l < buffer.length; l++) {\n        buf[l] = buffer[l] * (buffer[l] < 0 ? 0x8000 : 0x7fff);\n    }\n    return buf;\n}\nfunction generateFilter(sourceSampleRate, targetSampleRate, length) {\n    if (length % 2 === 0) {\n        throw Error('Filter length must be odd');\n    }\n    var cutoff = targetSampleRate / 2;\n    var filter = new Float32Array(length);\n    var sum = 0;\n    for (var i = 0; i < length; i++) {\n        var x = sinc(((2 * cutoff) / sourceSampleRate) * (i - (length - 1) / 2));\n        sum += x;\n        filter[i] = x;\n    }\n    for (var i = 0; i < length; i++) {\n        filter[i] = filter[i] / sum;\n    }\n    return filter;\n}\nfunction sinc(x) {\n    if (x === 0.0) {\n        return 1.0;\n    }\n    var piX = Math.PI * x;\n    return Math.sin(piX) / piX;\n}\n";

var WebWorkerController =
/*#__PURE__*/
function () {
  function WebWorkerController() {
    var _this3 = this;

    _classCallCheck(this, WebWorkerController);

    this.startCbs = [];
    this.stopCbs = [];

    this.onResponseCb = function () {};

    this.onCloseCb = function () {};

    this.onWebsocketMessage = function (event) {
      var response = event.data;

      switch (response.type) {
        case WebsocketResponseType.Opened:
          if (_this3.resolveInitialization != null) {
            _this3.resolveInitialization();
          }

          break;

        case WebsocketResponseType.Closed:
          _this3.onCloseCb({
            code: event.data.code,
            reason: event.data.reason,
            wasClean: event.data.wasClean
          });

          break;

        case WebsocketResponseType.SourceSampleRateSetSuccess:
          if (_this3.resolveSourceSampleRateSet != null) {
            _this3.resolveSourceSampleRateSet();
          }

          break;

        case WebsocketResponseType.Started:
          _this3.startCbs.forEach(function (cb) {
            try {
              cb(undefined, response.audio_context);
            } catch (e) {
              console.error('[SpeechlyClient] Error while invoking "onStart" callback:', e);
            }
          });

          _this3.startCbs.length = 0;
          break;

        case WebsocketResponseType.Stopped:
          _this3.stopCbs.forEach(function (cb) {
            try {
              cb(undefined, response.audio_context);
            } catch (e) {
              console.error('[SpeechlyClient] Error while invoking "onStop" callback:', e);
            }
          });

          _this3.stopCbs.length = 0;
          break;

        default:
          _this3.onResponseCb(response);

      }
    };

    var blob = new Blob([worker], {
      type: 'text/javascript'
    });
    var blobURL = window.URL.createObjectURL(blob);
    this.worker = new Worker(blobURL);
    this.worker.addEventListener('message', this.onWebsocketMessage);
  }

  _createClass(WebWorkerController, [{
    key: "onResponse",
    value: function onResponse(cb) {
      this.onResponseCb = cb;
    }
  }, {
    key: "onClose",
    value: function onClose(cb) {
      this.onCloseCb = cb;
    }
  }, {
    key: "initialize",
    value: function initialize(apiUrl, authToken, targetSampleRate, debug) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var _this4 = this;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.worker.postMessage({
                  type: 'INIT',
                  apiUrl: apiUrl,
                  authToken: authToken,
                  targetSampleRate: targetSampleRate,
                  debug: debug
                }); // Reset

                this.startCbs = [];
                this.stopCbs = [];
                return _context4.abrupt("return", new Promise(function (resolve) {
                  _this4.resolveInitialization = resolve;
                }));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "setSourceSampleRate",
    value: function setSourceSampleRate(sourceSampleRate) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var _this5 = this;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.worker.postMessage({
                  type: 'SET_SOURSE_SAMPLE_RATE',
                  sourceSampleRate: sourceSampleRate
                });
                return _context5.abrupt("return", new Promise(function (resolve) {
                  _this5.resolveSourceSampleRateSet = resolve;
                }));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "close",
    value: function close() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var _this6 = this;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", new Promise(function (resolve, reject) {
                  _this6.worker.postMessage({
                    type: 'CLOSE',
                    code: 1000,
                    message: 'Client has ended the session'
                  });

                  resolve();
                }));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "startContext",
    value: function startContext(appId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var _this7 = this;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", new Promise(function (resolve, reject) {
                  _this7.startCbs.push(function (err, id) {
                    if (err !== undefined) {
                      reject(err);
                    } else {
                      resolve(id);
                    }
                  });

                  if (appId != null) {
                    _this7.worker.postMessage({
                      type: 'START_CONTEXT',
                      appId: appId
                    });
                  } else {
                    _this7.worker.postMessage({
                      type: 'START_CONTEXT'
                    });
                  }
                }));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "stopContext",
    value: function stopContext() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        var _this8 = this;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", new Promise(function (resolve, reject) {
                  _this8.stopCbs.push(function (err, id) {
                    if (err !== undefined) {
                      reject(err);
                    } else {
                      resolve(id);
                    }
                  });

                  _this8.worker.postMessage({
                    type: 'STOP_CONTEXT'
                  });
                }));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "switchContext",
    value: function switchContext(appId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        var _this9 = this;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", new Promise(function (resolve, reject) {
                  _this9.startCbs.push(function (err, id) {
                    if (err !== undefined) {
                      reject(err);
                    } else {
                      resolve(id);
                    }
                  });

                  _this9.worker.postMessage({
                    type: 'SWITCH_CONTEXT',
                    appId: appId
                  });
                }));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "postMessage",
    value: function postMessage(message) {
      this.worker.postMessage(message);
    }
  }, {
    key: "sendAudio",
    value: function sendAudio(audioChunk) {
      this.worker.postMessage({
        type: 'AUDIO',
        payload: audioChunk
      });
    }
  }]);

  return WebWorkerController;
}();

var LocalStorage =
/*#__PURE__*/
function () {
  function LocalStorage() {
    _classCallCheck(this, LocalStorage);

    this.storage = window.localStorage;
  }

  _createClass(LocalStorage, [{
    key: "get",
    value: function get(key) {
      var val = this.storage.getItem(key);
      return val;
    }
  }, {
    key: "set",
    value: function set(key, val) {
      this.storage.setItem(key, val);
    }
  }, {
    key: "getOrSet",
    value: function getOrSet(key, genFn) {
      var val = this.storage.getItem(key);

      if (val === null) {
        val = genFn();
        this.storage.setItem(key, val);
      }

      return val;
    }
  }]);

  return LocalStorage;
}();
/**
 * Error to be thrown if storage API is not supported by the device.
 * @public
 */


var ErrNoStorageSupport = new Error('Current device does not support storage API');
/**
 * Error to be thrown if requested key was not found in the storage.
 * @public
 */

var ErrKeyNotFound = new Error('Requested key was not present in storage');

var SegmentState =
/*#__PURE__*/
function () {
  function SegmentState(ctxId, sId) {
    _classCallCheck(this, SegmentState);

    this.isFinalized = false;
    this.words = [];
    this.entities = new Map();
    this.intent = {
      intent: '',
      isFinal: false
    };
    this.contextId = ctxId;
    this.id = sId;
  }

  _createClass(SegmentState, [{
    key: "toSegment",
    value: function toSegment() {
      var i = 0;
      var entities = new Array(this.entities.size);
      this.entities.forEach(function (v) {
        entities[i] = v;
        i++;
      });
      return {
        id: this.id,
        contextId: this.contextId,
        isFinal: this.isFinalized,
        words: this.words,
        entities: entities,
        intent: this.intent
      };
    }
  }, {
    key: "toString",
    value: function toString() {
      var segment = this.toSegment();
      var words = segment.words.filter(function (w) {
        return w.value;
      }).map(function (w) {
        return {
          value: w.value,
          index: w.index
        };
      });
      var cleanSegment = Object.assign(Object.assign({}, segment), {
        words: words
      });
      return JSON.stringify(cleanSegment, null, 2);
    }
  }, {
    key: "updateTranscript",
    value: function updateTranscript(words) {
      var _this10 = this;

      words.forEach(function (w) {
        // Only accept tentative words if the segment is tentative.
        if (!_this10.isFinalized || w.isFinal) {
          _this10.words[w.index] = w;
        }
      });
      return this;
    }
  }, {
    key: "updateEntities",
    value: function updateEntities(entities) {
      var _this11 = this;

      entities.forEach(function (e) {
        // Only accept tentative entities if the segment is tentative.
        if (!_this11.isFinalized || e.isFinal) {
          _this11.entities.set(entityMapKey(e), e);
        }
      });
      return this;
    }
  }, {
    key: "updateIntent",
    value: function updateIntent(intent) {
      // Only accept tentative intent if the segment is tentative.
      if (!this.isFinalized || intent.isFinal) {
        this.intent = intent;
      }

      return this;
    }
  }, {
    key: "finalize",
    value: function finalize() {
      var _this12 = this;

      // Filter away any entities which were not finalized.
      this.entities.forEach(function (val, key) {
        if (!val.isFinal) {
          _this12.entities.delete(key);
        }
      }); // Filter away any transcripts which were not finalized.

      this.words = this.words.filter(function (w) {
        return w.isFinal;
      });

      if (!this.intent.isFinal) {
        this.intent.intent = '';
        this.intent.isFinal = true;
      } // Mark as final.


      this.isFinalized = true;
      return this;
    }
  }]);

  return SegmentState;
}();

function entityMapKey(e) {
  return "".concat(e.startPosition.toString(), ":").concat(e.endPosition.toString());
}

function parseTentativeTranscript(data) {
  return data.words.map(function (_ref) {
    var word = _ref.word,
        index = _ref.index,
        start_timestamp = _ref.start_timestamp,
        end_timestamp = _ref.end_timestamp;
    return {
      value: word,
      index: index,
      startTimestamp: start_timestamp,
      endTimestamp: end_timestamp,
      isFinal: false
    };
  });
}

function parseTranscript(data) {
  return {
    value: data.word,
    index: data.index,
    startTimestamp: data.start_timestamp,
    endTimestamp: data.end_timestamp,
    isFinal: true
  };
}

function parseTentativeEntities(data) {
  return data.entities.map(function (_ref2) {
    var entity = _ref2.entity,
        value = _ref2.value,
        start_position = _ref2.start_position,
        end_position = _ref2.end_position;
    return {
      type: entity,
      value: value,
      startPosition: start_position,
      endPosition: end_position,
      isFinal: false
    };
  });
}

function parseEntity(data) {
  return {
    type: data.entity,
    value: data.value,
    startPosition: data.start_position,
    endPosition: data.end_position,
    isFinal: true
  };
}

function parseIntent(data, isFinal) {
  return {
    intent: data.intent,
    isFinal: isFinal
  };
}

var deviceIdStorageKey = 'speechly-device-id';
var authTokenKey = 'speechly-auth-token';
var defaultApiUrl = 'wss://api.speechly.com/ws/v1';
var defaultLoginUrl = 'https://api.speechly.com/login';
/**
 * A client for Speechly Spoken Language Understanding (SLU) API. The client handles initializing the microphone
 * and websocket connection to Speechly API, passing control events and audio stream to the API, reading the responses
 * and dispatching them, as well as providing a high-level API for interacting with so-called speech segments.
 * @public
 */

var Client =
/*#__PURE__*/
function () {
  function Client(options) {
    var _this13 = this;

    _classCallCheck(this, Client);

    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;

    this.listening = false;
    this.activeContexts = new Map();
    this.maxReconnectAttemptCount = 10;
    this.contextStopDelay = 250;
    this.connectAttempt = 0;
    this.connectPromise = null;
    this.initializePromise = null;
    this.listeningPromise = null;
    this.state = ClientState.Disconnected;

    this.stateChangeCb = function () {};

    this.segmentChangeCb = function () {};

    this.tentativeTranscriptCb = function () {};

    this.tentativeEntitiesCb = function () {};

    this.tentativeIntentCb = function () {};

    this.transcriptCb = function () {};

    this.entityCb = function () {};

    this.intentCb = function () {};

    this.handleWebsocketResponse = function (response) {
      var _a;

      if (_this13.debug) {
        console.log('[SpeechlyClient]', 'Received response', response);
      }

      var audio_context = response.audio_context,
          segment_id = response.segment_id,
          type = response.type;
      var data = response.data;

      var context = _this13.activeContexts.get(audio_context);

      if (context === undefined) {
        console.warn('[SpeechlyClient]', 'Received response for non-existent context', audio_context);
        return;
      }

      var segmentState = (_a = context.get(segment_id)) !== null && _a !== void 0 ? _a : new SegmentState(audio_context, segment_id);

      switch (type) {
        case WebsocketResponseType.TentativeTranscript:
          data = data;
          var words = parseTentativeTranscript(data);

          _this13.tentativeTranscriptCb(audio_context, segment_id, words, data.transcript);

          segmentState = segmentState.updateTranscript(words);
          break;

        case WebsocketResponseType.Transcript:
          data = data;
          var word = parseTranscript(data);

          _this13.transcriptCb(audio_context, segment_id, word);

          segmentState = segmentState.updateTranscript([word]);
          break;

        case WebsocketResponseType.TentativeEntities:
          data = data;
          var entities = parseTentativeEntities(data);

          _this13.tentativeEntitiesCb(audio_context, segment_id, entities);

          segmentState = segmentState.updateEntities(entities);
          break;

        case WebsocketResponseType.Entity:
          data = data;
          var entity = parseEntity(data);

          _this13.entityCb(audio_context, segment_id, entity);

          segmentState = segmentState.updateEntities([entity]);
          break;

        case WebsocketResponseType.TentativeIntent:
          data = data;
          var tentativeIntent = parseIntent(data, false);

          _this13.tentativeIntentCb(audio_context, segment_id, tentativeIntent);

          segmentState = segmentState.updateIntent(tentativeIntent);
          break;

        case WebsocketResponseType.Intent:
          data = data;
          var intent = parseIntent(data, true);

          _this13.intentCb(audio_context, segment_id, intent);

          segmentState = segmentState.updateIntent(intent);
          break;

        case WebsocketResponseType.SegmentEnd:
          segmentState = segmentState.finalize();
          break;
        // TODO: handle unexpected response types.
      } // Update the segment in current context.


      context.set(segment_id, segmentState); // Update current contexts.

      _this13.activeContexts.set(audio_context, context); // Log segment to console


      if (_this13.logSegments) {
        console.info(segmentState.toString());
      } // Fire segment change event.


      _this13.segmentChangeCb(segmentState.toSegment());
    };

    this.handleWebsocketClosure = function (err) {
      if (err.code === 1000) {
        if (_this13.debug) {
          console.log('[SpeechlyClient]', 'Websocket closed', err);
        }
      } else {
        console.error('[SpeechlyClient]', 'Websocket closed due to error', err); // If for some reason deviceId is missing, there's nothing else we can do but fail completely.

        if (_this13.deviceId === undefined) {
          _this13.setState(ClientState.Failed);

          return;
        } // Reset


        _this13.listening = false;
        _this13.listeningPromise = null;

        _this13.microphone.mute();

        _this13.setState(ClientState.Disconnected); // eslint-disable-next-line @typescript-eslint/no-floating-promises


        _this13.reconnect();
      }
    };

    this.sampleRate = (_a = options.sampleRate) !== null && _a !== void 0 ? _a : DefaultSampleRate;

    try {
      var constraints = window.navigator.mediaDevices.getSupportedConstraints();
      this.nativeResamplingSupported = constraints.sampleRate === true;

      if (options.autoGainControl != null && options.autoGainControl) {
        // @ts-ignore
        this.autoGainControl = constraints.autoGainControl === true;
      } else {
        this.autoGainControl = false;
      }
    } catch (_m) {
      this.nativeResamplingSupported = false;
      this.autoGainControl = false;
    }

    this.debug = (_b = options.debug) !== null && _b !== void 0 ? _b : false;
    this.logSegments = (_c = options.logSegments) !== null && _c !== void 0 ? _c : false;
    this.loginUrl = (_d = options.loginUrl) !== null && _d !== void 0 ? _d : defaultLoginUrl;
    this.appId = (_e = options.appId) !== null && _e !== void 0 ? _e : undefined;
    this.projectId = (_f = options.projectId) !== null && _f !== void 0 ? _f : undefined;
    this.apiClient = (_g = options.apiClient) !== null && _g !== void 0 ? _g : new WebWorkerController();
    this.apiUrl = generateWsUrl((_h = options.apiUrl) !== null && _h !== void 0 ? _h : defaultApiUrl, (_j = options.sampleRate) !== null && _j !== void 0 ? _j : DefaultSampleRate);

    if (this.appId !== undefined && this.projectId !== undefined) {
      throw Error('[SpeechlyClient] You cannot use both appId and projectId at the same time');
    }

    this.storage = (_k = options.storage) !== null && _k !== void 0 ? _k : new LocalStorage();
    this.deviceId = this.storage.getOrSet(deviceIdStorageKey, v4);

    if (window.AudioContext !== undefined) {
      this.isWebkit = false;
    } else if (window.webkitAudioContext !== undefined) {
      this.isWebkit = true;
    } else {
      throw ErrDeviceNotSupported;
    }

    this.microphone = (_l = options.microphone) !== null && _l !== void 0 ? _l : new BrowserMicrophone(this.isWebkit, this.sampleRate, this.apiClient, this.debug);
    this.apiClient.onResponse(this.handleWebsocketResponse);
    this.apiClient.onClose(this.handleWebsocketClosure);
    window.SpeechlyClient = this;

    if (options.connect !== false) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.connect();
    }
  }

  _createClass(Client, [{
    key: "getReconnectDelayMs",
    value: function getReconnectDelayMs(attempt) {
      return Math.pow(2, attempt) * 100;
    }
  }, {
    key: "sleep",
    value: function sleep(ms) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", new Promise(function (resolve) {
                  return setTimeout(resolve, ms);
                }));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
    /**
     * @returns true if startContext is called and expecting stopContext next
     */

  }, {
    key: "isListening",
    value: function isListening() {
      return this.listening;
    }
    /**
     * Connect to Speechly backend.
     * This function will be called by initialize if not manually called earlier.
     * Calling connect() immediately after constructor and setting callbacks allows
     * prewarming the connection, resulting in less noticeable waits for the user.
     */

  }, {
    key: "connect",
    value: function connect() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12() {
        var _this14 = this;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (this.connectPromise === null) {
                  this.connectPromise = function () {
                    return __awaiter(_this14, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee11() {
                      var storedToken;
                      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                        while (1) {
                          switch (_context11.prev = _context11.next) {
                            case 0:
                              this.advanceState(ClientState.Connecting); // Get auth token from cache or renew it

                              storedToken = this.storage.get(authTokenKey);

                              if (!(storedToken == null || !validateToken(storedToken, this.projectId, this.appId, this.deviceId))) {
                                _context11.next = 16;
                                break;
                              }

                              _context11.prev = 3;
                              _context11.next = 6;
                              return fetchToken(this.loginUrl, this.projectId, this.appId, this.deviceId);

                            case 6:
                              this.authToken = _context11.sent;
                              // Cache the auth token in local storage for future use.
                              this.storage.set(authTokenKey, this.authToken);
                              _context11.next = 14;
                              break;

                            case 10:
                              _context11.prev = 10;
                              _context11.t0 = _context11["catch"](3);
                              this.setState(ClientState.Failed);
                              throw _context11.t0;

                            case 14:
                              _context11.next = 17;
                              break;

                            case 16:
                              this.authToken = storedToken;

                            case 17:
                              _context11.prev = 17;
                              _context11.next = 20;
                              return this.apiClient.initialize(this.apiUrl, this.authToken, this.sampleRate, this.debug);

                            case 20:
                              _context11.next = 26;
                              break;

                            case 22:
                              _context11.prev = 22;
                              _context11.t1 = _context11["catch"](17);
                              this.setState(ClientState.Failed);
                              throw _context11.t1;

                            case 26:
                            case "end":
                              return _context11.stop();
                          }
                        }
                      }, _callee11, this, [[3, 10], [17, 22]]);
                    }));
                  }();
                }

                _context12.next = 3;
                return this.connectPromise;

              case 3:
                this.advanceState(ClientState.Preinitialized);

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));
    }
    /**
     * Initializes the client, by initializing the microphone and establishing connection to the API.
     *
     * This function HAS to be invoked by a user by e.g. binding it to a button press,
     * or some other user-performed action.
     *
     * If this function is invoked without a user interaction,
     * the microphone functionality will not work due to security restrictions by the browser.
     */

  }, {
    key: "initialize",
    value: function initialize() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee14() {
        var _this15 = this;

        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                // Ensure we're connected. Returns immediately if we are
                if (this.initializePromise === null) {
                  this.initializePromise = function () {
                    return __awaiter(_this15, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee13() {
                      var opts, mediaStreamConstraints;
                      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
                        while (1) {
                          switch (_context13.prev = _context13.next) {
                            case 0:
                              _context13.next = 2;
                              return this.connect();

                            case 2:
                              this.advanceState(ClientState.Initializing);
                              _context13.prev = 3;

                              if (this.isWebkit) {
                                if (window.webkitAudioContext !== undefined) {
                                  // eslint-disable-next-line new-cap
                                  this.audioContext = new window.webkitAudioContext();
                                }
                              } else {
                                opts = {};

                                if (this.nativeResamplingSupported) {
                                  opts.sampleRate = this.sampleRate;
                                }

                                this.audioContext = new window.AudioContext(opts);
                              }

                              mediaStreamConstraints = {
                                video: false
                              };

                              if (this.nativeResamplingSupported || this.autoGainControl) {
                                mediaStreamConstraints.audio = {
                                  sampleRate: this.sampleRate,
                                  // @ts-ignore
                                  autoGainControl: this.autoGainControl
                                };
                              } else {
                                mediaStreamConstraints.audio = true;
                              }

                              if (!(this.audioContext != null)) {
                                _context13.next = 18;
                                break;
                              }

                              if (!this.isWebkit) {
                                _context13.next = 11;
                                break;
                              }

                              _context13.next = 11;
                              return this.audioContext.resume();

                            case 11:
                              _context13.next = 13;
                              return this.apiClient.setSourceSampleRate(this.audioContext.sampleRate);

                            case 13:
                              _context13.next = 15;
                              return this.microphone.initialize(this.audioContext, mediaStreamConstraints);

                            case 15:
                              this.advanceState(ClientState.Connected);
                              _context13.next = 19;
                              break;

                            case 18:
                              throw ErrDeviceNotSupported;

                            case 19:
                              _context13.next = 32;
                              break;

                            case 21:
                              _context13.prev = 21;
                              _context13.t0 = _context13["catch"](3);
                              _context13.t1 = _context13.t0;
                              _context13.next = _context13.t1 === ErrDeviceNotSupported ? 26 : _context13.t1 === ErrNoAudioConsent ? 28 : 30;
                              break;

                            case 26:
                              this.setState(ClientState.NoBrowserSupport);
                              return _context13.abrupt("break", 31);

                            case 28:
                              this.setState(ClientState.NoAudioConsent);
                              return _context13.abrupt("break", 31);

                            case 30:
                              this.setState(ClientState.Failed);

                            case 31:
                              throw _context13.t0;

                            case 32:
                            case "end":
                              return _context13.stop();
                          }
                        }
                      }, _callee13, this, [[3, 21]]);
                    }));
                  }();
                }

                _context14.next = 3;
                return this.initializePromise;

              case 3:
                this.advanceState(ClientState.Connected);

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));
    }
    /**
     * Closes the client by closing the API connection and disabling the microphone.
     */

  }, {
    key: "close",
    value: function close() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee15() {
        var errs;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                errs = [];
                _context15.prev = 1;
                _context15.next = 4;
                return this.microphone.close();

              case 4:
                _context15.next = 9;
                break;

              case 6:
                _context15.prev = 6;
                _context15.t0 = _context15["catch"](1);
                // @ts-ignore
                errs.push(_context15.t0.message);

              case 9:
                _context15.prev = 9;
                _context15.next = 12;
                return this.apiClient.close();

              case 12:
                _context15.next = 17;
                break;

              case 14:
                _context15.prev = 14;
                _context15.t1 = _context15["catch"](9);
                // @ts-ignore
                errs.push(_context15.t1.message);

              case 17:
                this.activeContexts.clear();
                this.connectPromise = null;
                this.initializePromise = null;
                this.setState(ClientState.Disconnected);

                if (!(errs.length > 0)) {
                  _context15.next = 23;
                  break;
                }

                throw Error(errs.join(','));

              case 23:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[1, 6], [9, 14]]);
      }));
    }
  }, {
    key: "hasUnrecoverableError",
    value: function hasUnrecoverableError() {
      return this.state < ClientState.__UnrecoverableErrors;
    }
  }, {
    key: "queueTask",
    value: function queueTask(task) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee17() {
        var _this16 = this;

        var prevTask;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                prevTask = this.listeningPromise;

                this.listeningPromise = function () {
                  return __awaiter(_this16, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee16() {
                    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
                      while (1) {
                        switch (_context16.prev = _context16.next) {
                          case 0:
                            _context16.next = 2;
                            return prevTask;

                          case 2:
                            return _context16.abrupt("return", task());

                          case 3:
                          case "end":
                            return _context16.stop();
                        }
                      }
                    }, _callee16, this);
                  }));
                }();

                return _context17.abrupt("return", this.listeningPromise);

              case 3:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));
    }
    /**
     * Starts a new SLU context by sending a start context event to the API and unmuting the microphone.
     * @param cb - the callback which is invoked when the context start was acknowledged by the API.
     */

  }, {
    key: "startContext",
    value: function startContext(appId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee19() {
        var _this17 = this;

        var contextId;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                if (this.hasUnrecoverableError()) {
                  _context19.next = 8;
                  break;
                }

                if (!this.listening) {
                  _context19.next = 3;
                  break;
                }

                throw Error('Already listening');

              case 3:
                this.listening = true;
                _context19.next = 6;
                return this.queueTask(function () {
                  return __awaiter(_this17, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee18() {
                    var contextId;
                    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
                      while (1) {
                        switch (_context18.prev = _context18.next) {
                          case 0:
                            if (!(this.state < ClientState.Connected)) {
                              _context18.next = 3;
                              break;
                            }

                            _context18.next = 3;
                            return this.initialize();

                          case 3:
                            if (!(this.state !== ClientState.Connected)) {
                              _context18.next = 5;
                              break;
                            }

                            throw Error('[SpeechlyClient] Unable to complete startContext: Expected Connected state, but was in ' + stateToString(this.state) + '. Did you call startContext multiple times without stopContext?');

                          case 5:
                            this.setState(ClientState.Starting);
                            this.microphone.unmute(); // Fetch context id

                            if (!(this.projectId != null)) {
                              _context18.next = 13;
                              break;
                            }

                            _context18.next = 10;
                            return this.apiClient.startContext(appId);

                          case 10:
                            contextId = _context18.sent;
                            _context18.next = 19;
                            break;

                          case 13:
                            if (!(appId != null && this.appId !== appId)) {
                              _context18.next = 16;
                              break;
                            }

                            this.setState(ClientState.Failed);
                            throw ErrAppIdChangeWithoutProjectLogin;

                          case 16:
                            _context18.next = 18;
                            return this.apiClient.startContext();

                          case 18:
                            contextId = _context18.sent;

                          case 19:
                            if (!(this.state !== ClientState.Starting)) {
                              _context18.next = 21;
                              break;
                            }

                            throw Error('[SpeechlyClient] Unable to complete startContext: Problem acquiring contextId');

                          case 21:
                            this.activeContexts.set(contextId, new Map());
                            this.setState(ClientState.Recording);
                            return _context18.abrupt("return", contextId);

                          case 24:
                          case "end":
                            return _context18.stop();
                        }
                      }
                    }, _callee18, this);
                  }));
                });

              case 6:
                contextId = _context19.sent;
                return _context19.abrupt("return", contextId);

              case 8:
                throw Error('[SpeechlyClient] startContext cannot be run in unrecovable error state.');

              case 9:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));
    }
    /**
     * Stops current SLU context by sending a stop context event to the API and muting the microphone
     * delayed by contextStopDelay = 250 ms
     */

  }, {
    key: "stopContext",
    value: function stopContext() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee21() {
        var _this18 = this;

        var contextId;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                if (this.hasUnrecoverableError()) {
                  _context21.next = 8;
                  break;
                }

                if (this.listening) {
                  _context21.next = 3;
                  break;
                }

                throw Error('Already stopped listening');

              case 3:
                this.listening = false;
                _context21.next = 6;
                return this.queueTask(function () {
                  return __awaiter(_this18, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee20() {
                    var _contextId;

                    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
                      while (1) {
                        switch (_context20.prev = _context20.next) {
                          case 0:
                            if (!(this.state !== ClientState.Recording)) {
                              _context20.next = 2;
                              break;
                            }

                            throw Error('[SpeechlyClient] Unable to complete stopContext: Expected Recording state, but was in ' + stateToString(this.state) + '.');

                          case 2:
                            this.setState(ClientState.Stopping);
                            _context20.next = 5;
                            return this.sleep(this.contextStopDelay);

                          case 5:
                            this.microphone.mute();
                            _context20.prev = 6;
                            _context20.next = 9;
                            return this.apiClient.stopContext();

                          case 9:
                            _contextId = _context20.sent;
                            this.activeContexts.delete(_contextId);
                            this.setState(ClientState.Connected);
                            return _context20.abrupt("return", _contextId);

                          case 15:
                            _context20.prev = 15;
                            _context20.t0 = _context20["catch"](6);
                            this.setState(ClientState.Failed);
                            throw _context20.t0;

                          case 19:
                          case "end":
                            return _context20.stop();
                        }
                      }
                    }, _callee20, this, [[6, 15]]);
                  }));
                });

              case 6:
                contextId = _context21.sent;
                return _context21.abrupt("return", contextId);

              case 8:
                throw Error('[SpeechlyClient] stopContext cannot be run in unrecovable error state.');

              case 9:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));
    }
    /**
     * Stops current context and immediately starts a new SLU context
     * by sending a start context event to the API and unmuting the microphone.
     * @param appId - unique identifier of an app in the dashboard.
     */

  }, {
    key: "switchContext",
    value: function switchContext(appId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee23() {
        var _this19 = this;

        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.next = 2;
                return this.queueTask(function () {
                  return __awaiter(_this19, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee22() {
                    var contextId;
                    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
                      while (1) {
                        switch (_context22.prev = _context22.next) {
                          case 0:
                            if (!(this.state !== ClientState.Recording)) {
                              _context22.next = 2;
                              break;
                            }

                            throw Error('[SpeechlyClient] Unable to complete switchContext: Expected Recording state, but was in ' + stateToString(this.state) + '.');

                          case 2:
                            _context22.next = 4;
                            return this.apiClient.switchContext(appId);

                          case 4:
                            contextId = _context22.sent;
                            this.activeContexts.set(contextId, new Map());

                          case 6:
                          case "end":
                            return _context22.stop();
                        }
                      }
                    }, _callee22, this);
                  }));
                });

              case 2:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));
    }
    /**
     * Adds a listener for client state change events.
     * @param cb - the callback to invoke on state change events.
     */

  }, {
    key: "onStateChange",
    value: function onStateChange(cb) {
      this.stateChangeCb = cb;
    }
    /**
     * Adds a listener for current segment change events.
     * @param cb - the callback to invoke on segment change events.
     */

  }, {
    key: "onSegmentChange",
    value: function onSegmentChange(cb) {
      this.segmentChangeCb = cb;
    }
    /**
     * Adds a listener for tentative transcript responses from the API.
     * @param cb - the callback to invoke on a tentative transcript response.
     */

  }, {
    key: "onTentativeTranscript",
    value: function onTentativeTranscript(cb) {
      this.tentativeTranscriptCb = cb;
    }
    /**
     * Adds a listener for transcript responses from the API.
     * @param cb - the callback to invoke on a transcript response.
     */

  }, {
    key: "onTranscript",
    value: function onTranscript(cb) {
      this.transcriptCb = cb;
    }
    /**
     * Adds a listener for tentative entities responses from the API.
     * @param cb - the callback to invoke on a tentative entities response.
     */

  }, {
    key: "onTentativeEntities",
    value: function onTentativeEntities(cb) {
      this.tentativeEntitiesCb = cb;
    }
    /**
     * Adds a listener for entity responses from the API.
     * @param cb - the callback to invoke on an entity response.
     */

  }, {
    key: "onEntity",
    value: function onEntity(cb) {
      this.entityCb = cb;
    }
    /**
     * Adds a listener for tentative intent responses from the API.
     * @param cb - the callback to invoke on a tentative intent response.
     */

  }, {
    key: "onTentativeIntent",
    value: function onTentativeIntent(cb) {
      this.tentativeIntentCb = cb;
    }
    /**
     * Adds a listener for intent responses from the API.
     * @param cb - the callback to invoke on an intent response.
     */

  }, {
    key: "onIntent",
    value: function onIntent(cb) {
      this.intentCb = cb;
    }
  }, {
    key: "reconnect",
    value: function reconnect() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee24() {
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                if (this.debug) {
                  console.log('[SpeechlyClient]', 'Reconnecting...', this.connectAttempt);
                }

                this.connectPromise = null;

                if (!(!this.hasUnrecoverableError() && this.connectAttempt < this.maxReconnectAttemptCount)) {
                  _context24.next = 9;
                  break;
                }

                _context24.next = 5;
                return this.sleep(this.getReconnectDelayMs(this.connectAttempt++));

              case 5:
                _context24.next = 7;
                return this.connect();

              case 7:
                _context24.next = 10;
                break;

              case 9:
                console.error('[SpeechlyClient] Maximum reconnect count reached, giving up automatic reconnect.');

              case 10:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));
    }
  }, {
    key: "advanceState",
    value: function advanceState(newState) {
      if (this.state >= newState) {
        return;
      }

      this.setState(newState);
    }
  }, {
    key: "setState",
    value: function setState(newState) {
      if (this.state === newState) {
        return;
      }

      if (this.debug) {
        console.log('[SpeechlyClient]', stateToString(this.state), '->', stateToString(newState));
      }

      this.state = newState;
      this.stateChangeCb(newState);
    }
    /**
     * print statistics to console
     */

  }, {
    key: "printStats",
    value: function printStats() {
      this.microphone.printStats();
    }
  }]);

  return Client;
}();

function generateWsUrl(baseUrl, sampleRate) {
  var params = new URLSearchParams();
  params.append('sampleRate', sampleRate.toString());
  return "".concat(baseUrl, "?").concat(params.toString());
}

export { Client, ClientState, DefaultSampleRate, ErrAlreadyInitialized, ErrAppIdChangeWithoutProjectLogin, ErrDeviceNotSupported, ErrKeyNotFound, ErrNoAudioConsent, ErrNoStorageSupport, ErrNotInitialized, WebsocketResponseType, stateToString };